"use strict";
// Copyright (c) StrangeBee 2023
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
class ChartController extends __1.ParentController {
    constructor() {
        super(...arguments);
        this.endpoints = {
            time: '/v1/chart/time',
            category: '/v1/chart/category',
            timeCategory: '/v1/chart/timeCategory',
            query: '/v1/chart/query',
        };
    }
    count() {
        throw new Error("Can't count chart");
    }
    create({}) {
        throw new Error("Can't create chart!");
    }
    edit({}) {
        throw new Error("Can't edit chart!");
    }
    delete() {
        throw new Error("Can't delete chart!");
    }
    getChartTime(chartData) {
        return this.manager.post({ url: this.endpoints.time }, withLocaleInfo(chartData));
    }
    getChartCategory(chartData) {
        return this.manager.post({ url: this.endpoints.category }, chartData);
    }
    getChartTimeCategory(chartData) {
        return this.manager.post({ url: this.endpoints.timeCategory }, withLocaleInfo(chartData));
    }
    getChartQuery(chartData) {
        return this.manager.post({ url: this.endpoints.query }, chartData);
    }
}
function withLocaleInfo(data) {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const locale = navigator.language;
    return Object.assign(Object.assign({}, data), { interval: `${data.interval}|${timeZone}|${locale}` });
}
exports.default = ChartController;
